export { default as SchemaOptions } from './definitions/SchemaOptions';
export { default as validateV1 } from './functions/validate';
export { default as extractV1Metadata } from './functions/extractMetadata';

// domain models
export { default as ComparisonDocument } from './models/ComparisonDocument';

export const VERSION = 1;
